export default "__VITE_ASSET__27d33657__"